var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  "+_vm._s(_vm.a())+"\n  "),_c('div',[_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index,class:['li', {'selected': item.selected}],on:{"click":function($event){_vm.change(item, index)}}},[_vm._v(" "+_vm._s(item)+" ")])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.2@vue-loader/lib/template-compiler?{"id":"data-v-e295c126","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/edit-plan/test.vue
// module id = null
// module chunks = 